import React from 'react';
import { useSettings } from '../../context/SettingsContext';
import './FloatingPanel.scss';

const FloatingPanel = () => {
  const { theme, toggleTheme, language, toggleLanguage } = useSettings();

  return (
    <div className="floating-panel">
      <button 
        className="panel-btn theme-btn" 
        onClick={toggleTheme}
        title={theme === 'light' ? 'Включить темную тему' : 'Включить светлую тему'}
      >
        {theme === 'light' ? (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
          </svg>
        ) : (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="5"></circle>
            <line x1="12" y1="1" x2="12" y2="3"></line>
            <line x1="12" y1="21" x2="12" y2="23"></line>
            <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
            <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
            <line x1="1" y1="12" x2="3" y2="12"></line>
            <line x1="21" y1="12" x2="23" y2="12"></line>
            <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
            <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
          </svg>
        )}
      </button>

      <button 
        className="panel-btn lang-btn" 
        onClick={toggleLanguage}
        title="Сменить язык / Тилди өзгөртүү"
      >
        <div className="lang-icon">
          {language === 'ru' ? 'RU' : 'KG'}
        </div>
      </button>
    </div>
  );
};

export default FloatingPanel;
